// extracted by mini-css-extract-plugin
export var actionButton = "_8j-1";
export var actionButtons = "_8j-2";
export var actions = "_8j-0";
export var aiUnread = "_8j-10";
export var alignCenter = "_8j-h";
export var backWrapper = "_8j-3";
export var cellContainer = "_8j-4";
export var checkboxContainer = "_8j-5";
export var contentContainer = "_8j-6";
export var contentHeader = "_8j-8";
export var conversationsTableWrapper = "_8j-s";
export var draftReplyBadgeContainer = "_8j-m";
export var dropdownItem = "_8j-b";
export var dropdownItemsContainer = "_8j-a";
export var dropdownTitle = "_8j-c";
export var errorIcon = "_8j-7";
export var filter = "_8j-d";
export var gray = "_8j-i";
export var headerActionButtons = "_8j-e";
export var headerCheckboxContainer = "_8j-f";
export var icon = "_8j-j";
export var menuContainer = "_8j-k";
export var noMoreTicketsIcon = "_8j-12";
export var noMoreTicketsSubText = "_8j-13";
export var oneLine = "_8j-l";
export var optionsButton = "_8j-n";
export var plus = "_8j-o";
export var portalButtonsWrapper = "_8j-g";
export var red = "_8j-p";
export var scrolledTop = "_8j-9";
export var search = "_8j-q";
export var selectedConversationsCount = "_8j-r";
export var spinner = "_8j-t";
export var strong = "_8j-u";
export var summaryCell = "_8j-v";
export var tableContainer = "_8j-11";
export var tagContainer = "_8j-w";
export var threeDots = "_8j-x";
export var twoLines = "_8j-y";
export var unread = "_8j-z";